import React from "react";
import { useTranslation } from "react-i18next";
import Navbar from "./Navbar";
import Trustbar from "./Trustbar"
import Painpoints from "./Painpoints"
import Features from "./Features"
import Howitworks from "./Howitworks"
import Industries from "./Industries"
import Hardwares from "./Hardwares"
import Pricing from "./Pricing"
import Testimonials from "./Testimonials"
import Compliance from "./Compliance"
import FAQ from "./FAQ"
import Ctaband from "./Ctaband"
import Footer from "./Footer"
import {
    Package,
    Receipt,
    Phone,
    Wifi,
    Star,
    Check,
} from "lucide-react";
import HeroBg from '../../assets/hero-bg.png'


const Herosection = () => {
    const { t } = useTranslation();

    return (
        < >
            <Navbar />
            <section className="relative overflow-hidden bg-[#070e22] pt-24 pb-16 md:pt-28 md:pb-24">
                <div
                    className="absolute inset-0 z-0 bg-cover bg-center"
                    style={{
                        backgroundImage: `url(${HeroBg})`, backgroundPosition: "center 0%"  // ← moves image down, change % to taste
                    }}
                />
                <div className="absolute inset-0 z-0 bg-[#0a1628]/65" />

                <div className="relative mx-auto px-2" style={{ maxWidth: "1280px" }}>
                    <div className="grid items-center z-10 gap-[50px] lg:grid-cols-[1.1fr_.9fr]">

                        {/* LEFT CONTENT */}
                        <div className="px-4 sm:px-0">
                            <h1 className="mb-[18px] font-extrabold leading-[1.08] tracking-normal text-white">                  {/* Heading */}
                                <span className="block text-[clamp(28px,5vw,58px)] whitespace-nowrap mb-1">
                                    {t("Run your store smarter.")}
                                </span>
                                <span className="block text-[clamp(24px,4.5vw,52px)] whitespace-nowrap bg-gradient-to-r from-[#60a5fa] to-[#38bdf8] bg-clip-text text-transparent">
                                    {t("Set it up in 10 minutes.")}
                                </span>
                            </h1>
                            {/* Paragraph */}
                            <p className="mb-7 max-w-[560px] text-[15px] sm:text-[16px] md:text-[18px] text-white/80 leading-relaxed">                                {t(
                                "Hisabak is the all-in-one POS & store management system built for Egyptian retailers. Sell faster, track inventory, print receipts, and grow from your phone or tablet, in Arabic or English."
                            )}
                            </p>

                            {/* CTA Buttons */}
                            <div className="mb-6 flex flex-wrap gap-3">
                                <a
                                    href="https://wa.me/201004505666?text=I%20want%20to%20start%20with%20Hisabak"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex items-center gap-2 rounded-xl bg-green-600 px-6 py-3 font-semibold text-white shadow-lg transition hover:bg-green-700"
                                >
                                    {t("Start Free on WhatsApp")}
                                </a>

                                <a
                                    href="tel:+201004505666"
                                    className="flex items-center gap-2 rounded-xl border border-white/30 bg-white/10 backdrop-blur-sm px-6 py-3 font-semibold text-white transition hover:bg-white/20 hover:border-white/60"
                                >
                                    <Phone size={18} />
                                    <span>{t("Call Sales")}</span>
                                </a>
                            </div>

                            {/* Trust */}
                            <div className="flex flex-wrap items-center gap-5 text-sm text-white/60">
                                <div className="flex items-center gap-2">
                                    <span className="flex items-center gap-1 text-amber-500">
                                        <Star size={14} fill="currentColor" />
                                        <Star size={14} fill="currentColor" />
                                        <Star size={14} fill="currentColor" />
                                        <Star size={14} fill="currentColor" />
                                        <Star size={14} fill="currentColor" />
                                    </span>

                                    <span>{t("4.8 / 5 (412 reviews)")}</span>
                                </div>

                                <div className="flex items-center gap-1">
                                    <Check size={14} className="text-green-600" />
                                    <span>{t("Trusted by 1,000+ stores")}</span>
                                </div>

                                <div className="flex items-center gap-1">
                                    <Check size={14} className="text-green-600" />
                                    <span>{t("No credit card needed")}</span>
                                </div>

                            </div>


                        </div>

                        {/* RIGHT VISUAL */}
                        <div className="relative flex justify-center p-4 md:px-0">
                            {/* Phone Mockup */}
                            <div className="relative z-10 h-full w-[92%] sm:w-full max-w-[500px] rotate-[-2deg] rounded-[28px] bg-gradient-to-b from-slate-900 to-slate-800 p-3 sm:p-[14px] shadow-2xl">
                                {/* Floating Card 1 */}
                                <div className="absolute left-2 top-[8%] z-50 flex items-center gap-2 rounded-xl bg-[#0f172a]/90 backdrop-blur-sm border border-white/10 text-white px-3 py-2 text-[11px] font-semibold shadow-xl sm:left-[-40px] sm:top-[10%] sm:gap-3 sm:rounded-[14px] sm:px-[18px] sm:py-[14px] sm:text-[13px] animate-[bounce_4s_infinite]">
                                    <div className="grid h-9 w-9 place-items-center rounded-[9px] bg-green-100 text-lg text-green-600">
                                        <Package size={18} />
                                    </div>

                                    <div>
                                        {t("Stock synced")} <br />
                                        {t("Across 3 branches")}
                                    </div>
                                </div>

                                {/* Floating Card 2 */}
                                <div className="absolute bottom-[10%] right-2 z-50 flex items-center gap-2 rounded-xl bg-[#0f172a]/90 backdrop-blur-sm border border-white/10 text-white px-3 py-2 text-[11px] font-semibold shadow-xl sm:bottom-[12%] sm:right-[-40px] sm:gap-3 sm:rounded-[14px] sm:px-[18px] sm:py-[14px] sm:text-[13px] animate-[bounce_4s_infinite]">
                                    <div className="grid h-9 w-9 place-items-center rounded-[9px] bg-yellow-100 text-lg text-yellow-600">
                                        <Receipt size={18} />
                                    </div>

                                    <div>
                                        {t("Receipt printed")} <br />
                                        {t("In Arabic, in 2 sec")}
                                    </div>
                                </div>

                                <div className="min-h-[480px] rounded-[18px] bg-white p-5">

                                    {/* Header */}
                                    <div className="mb-[18px] flex items-center justify-between border-b border-gray-200 pb-[14px]">
                                        <div className="text-[20px] font-bold">
                                            {t("Today's Sales")}
                                        </div>

                                        <div className="flex items-center gap-3">
                                            <div><Wifi size={18} className="text-gray-600" /></div>

                                            <div className="rounded-md bg-green-600 px-2 py-1 text-[11px] font-semibold text-white">
                                                {t("Live")}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Stats */}
                                    <div className="mb-[10px] flex items-center justify-between rounded-[10px] bg-gradient-to-r from-[#1B4597] to-[#2557C7] p-3 text-white">                                        <div className="text-[13px]">{t("Total Revenue")}</div>

                                        <div className="text-[18px] font-bold">
                                            {t("EGP 12,480")}
                                        </div>
                                    </div>

                                    <div className="mb-[10px] flex items-center justify-between rounded-[10px] bg-gray-100 p-3">
                                        <div className="text-[13px] text-gray-500">
                                            {t("Transactions")}
                                        </div>

                                        <div className="text-[18px] font-bold">{t("45")}</div>
                                    </div>

                                    <div className="mb-[10px] flex items-center justify-between rounded-[10px] bg-gray-100 p-3">
                                        <div className="text-[13px] text-gray-500">
                                            {t("Top Product")}
                                        </div>

                                        <div className="text-[18px] font-bold">
                                            {t("Coca-Cola 500ml")}
                                        </div>
                                    </div>

                                    {/* Top Items */}
                                    <div className="mt-[18px] text-[13px] font-bold uppercase tracking-[1px]">
                                        {t("Top Items")}
                                    </div>

                                    <div className="flex justify-between border-b border-dashed border-gray-300 py-[10px] text-[14px]">
                                        <span>{t("Coca-Cola 1L")}</span>
                                        <span>{t("x24")}</span>
                                    </div>

                                    <div className="flex justify-between border-b border-dashed border-gray-300 py-[10px] text-[14px]">
                                        <span>{t("Lays Chips")}</span>
                                        <span>{t("x18")}</span>
                                    </div>

                                    <div className="flex justify-between border-b border-dashed border-gray-300 py-[10px] text-[14px]">
                                        <span>{t("Bread Loaf")}</span>
                                        <span>{t("x15")}</span>
                                    </div>

                                    {/* Total */}
                                    <div className="mt-[14px] flex justify-between border-t-2 border-black pt-[14px] text-[18px] font-extrabold">
                                        <span>{t("Profit today")}</span>
                                        <span>{t("EGP 3,210")}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <Trustbar />
            <Painpoints />
            <Features />
            <Howitworks />
            <Industries />
            <Hardwares />
            <Pricing />
            <Testimonials />
            {/* <Compliance /> */}
            <FAQ />
            <Ctaband />
            <Footer />
        </>
    );
};

export default Herosection;